module.exports = __webpack_public_path__ + "img/75fae339e7c6353b4d53fc02aae4a25c.png";